import { thunk } from 'easy-peasy'
import { datasetRecord } from '../../../api/index'

export const dataSetRecordModel = {
    exportQuarterReportExcel: thunk(async (actions, payload) => {
        const res = await datasetRecord.exportQuarterReportExcel(payload)
        if (res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `รายงานประจำไตรมาส_${parseInt(payload.Year) + 543}-${payload.Quarter}.xlsx`);
            document.body.appendChild(link);
            link.click();
            return true
        }
        return false
    }),
}